"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _default = _react.default.createClass({
  displayName: "UIPanelSection",
  propTypes: (0, _extends2.default)({}, _UISection.default.propTypes, {
    children: _react.PropTypes.node
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UISection.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement(_UISection.default, (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)(className, 'private-panel__section')
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;